module.exports = __webpack_public_path__ + "static/media/iPhone-X-PSD-Mockup-01-no-shadow.975ef9de.png";